import { Component, ElementRef, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { TransferService } from '../../../_provider/transfer.service';
import { IonContent, ModalController, NavParams, PopoverController } from '@ionic/angular';
import { CrmService } from '../../../_provider/crm.service';
import { HttpFunctionResult } from '../../../_interfaces/HttpFunctionResult';
import { DarkmodeService } from '../../../_provider/darkmode.service';
import { ContactPerson } from '../../../_interfaces/ContactPerson';
import { AFSInputType, FeedbackService } from 'src/app/_provider/feedback.service';
import { ArrowKeysOptions } from 'src/app/_directives/ArrowKeysUseable.directive';

@Component({
  selector: 'app-ansprechpartner-popover',
  templateUrl: './ansprechpartner-popover.page.html',
  styleUrls: ['./ansprechpartner-popover.page.scss'],
})
export class AnsprechpartnerPopoverPage {

  @ViewChild('search', {static: false}) searchElement: ElementRef;
  @ViewChild(IonContent, {static: true}) contentRef: IonContent;
  public addressId: number
  public searchMode: boolean = true
  public selectedItem: number = 0

  public filterValue: string = ""
  public isLoading: boolean = true
  public loadingCount = new Array(4)

  public contactPersons: ContactPerson[] = []

  public type: "modal" | "popover"

  public arrowKeysOptions: ArrowKeysOptions = {
    selectedItem: -1,
    mouseOverItem: new EventEmitter<number>(null),
    mouseMove: new EventEmitter<boolean>(null),
    enterPressed: (index: number) =>{
      this.select(this.contactPersons[index])
    }
  }

  constructor(
    private transfer: TransferService, 
    private navParams: NavParams,
    public darkmode: DarkmodeService,
    private modalCtrl: ModalController,
    private CRMSrv: CrmService,
    private feedback: FeedbackService,
    private popover: PopoverController,) {

    this.addressId = this.navParams.get<number>("addressId")
    this.type = this.navParams.get<"modal" | "popover">("type")
    this.search()
  } 

  public async search(){
    const result: HttpFunctionResult<ContactPerson[]> = await this.CRMSrv.getBasicContactPersonList(this.addressId, this.filterValue)
    this.isLoading = false
    if(!result.success) return
    this.contactPersons = result.data
  }

  ngAfterViewInit(){
    this.arrowKeysOptions.ionContent = this.contentRef
    setTimeout(() =>{
      if(this.searchElement) this.searchElement.nativeElement.focus()
    }, 600);
  }

  public async select(ap: ContactPerson){
    if(this.searchMode) {
      this.transfer.setVALUE(ap)
      await this.feedback.hideKeyboardOnIOS()
    } 
    if(this.type == "popover") {
      if(!this.searchMode){
        if(!ap){
          
          const inputResult: HttpFunctionResult<string> = await this.feedback.showInput({
            header: "Kunde",
            message: "Bitte geben Sie den vollen Namen des Kunden ein.",
            placeholder: "Max Mustermann...",
            type: AFSInputType.TEXT,
            autofocus: true
          })

          if(inputResult.success) await this.popover.dismiss({item: inputResult.data})
          else return
        }
        else await this.popover.dismiss({item: `${ap.firstName || ""} ${ap.lastName || ""}`})
      }else await this.popover.dismiss()
    }
    else await this.modalCtrl.dismiss()
  }
 
  private filterTimeout: any
  public setFilter(event: KeyboardEvent): void {
    const isArrow: boolean = event.key == "ArrowUp" || event.key == "ArrowDown" || event.key == "Enter"
    if(isArrow) return
    this.isLoading = true
    clearTimeout(this.filterTimeout)
    this.filterTimeout = setTimeout(async () => {
      await this.search()
      if(event.key != "ArrowUp" && event.key != "ArrowDown" && event.key != "Enter")
      if(this.contactPersons.length > 0) this.arrowKeysOptions.selectedItem = 0 
      else this.arrowKeysOptions.selectedItem = -1
    }, 300);
  }

  public keydown(event: KeyboardEvent){
    switch(event.key){
      case "ArrowUp":
        if(this.selectedItem > 0)
        this.selectedItem--
        break
      case "ArrowDown":
        if(this.selectedItem < this.contactPersons.length - 1)
        this.selectedItem++
        break
    }
  }

  public keyup(event: KeyboardEvent){
    if(event.key == "Enter")
    this.select(this.contactPersons[this.selectedItem])
  }

  public async close(){
    await this.feedback.hideKeyboardOnIOS()
    await this.modalCtrl.dismiss()
  }

}
